import React, { useEffect, useState, useMemo, useCallback } from "react";
import api from "../api/api";
import GalleryCard from "../components/GalleryCard";
import "../styles/gallery.css";

const BASE_URL = "http://127.0.0.1:8000";

const Gallery = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  // ✅ Fetch Function (Reusable for auto refresh)
  const fetchGallery = useCallback(async () => {
    try {
      const res = await api.get("/gallery/");

      const fixedData = Array.isArray(res.data)
        ? res.data.map(item => ({
            ...item,
            image: item.image?.startsWith("http")
              ? item.image
              : item.image
              ? BASE_URL + item.image
              : null
          }))
        : [];

      setItems(fixedData);
      setError(null);
    } catch (err) {
      console.error("Gallery fetch error:", err);
      setError("Failed to load gallery.");
    } finally {
      setLoading(false);
    }
  }, []);

  // ✅ Initial Load + Auto Refresh (Admin changes reflect automatically)
  useEffect(() => {
    fetchGallery();

    const interval = setInterval(() => {
      fetchGallery();
    }, 15000); // 15 sec refresh

    return () => clearInterval(interval);
  }, [fetchGallery]);

  // ✅ Dynamic Categories (Auto generate from DB)
  const categories = useMemo(() => {
    const allCategories = items
      .map(i => i.category)
      .filter(Boolean);

    return ["all", ...new Set(allCategories)];
  }, [items]);

  const filteredItems =
    filter === "all"
      ? items
      : items.filter(
          i =>
            i.category &&
            i.category.toLowerCase() === filter.toLowerCase()
        );

  return (
    <div className="gallery-container">
      <h1 className="gallery-title">Our NGO Photo Gallery</h1>

      {/* ✅ Category Dropdown (Dynamic) */}
      <select
        value={filter}
        onChange={e => setFilter(e.target.value)}
        className="gallery-filter"
      >
        {categories.map((cat, index) => (
          <option key={index} value={cat}>
            {cat}
          </option>
        ))}
      </select>

      {loading && <p>Loading gallery...</p>}
      {!loading && error && <p className="error">{error}</p>}
      {!loading && !error && filteredItems.length === 0 && (
        <p>No gallery items found.</p>
      )}

      <div className="gallery-grid">
        {filteredItems.map(item => (
          <GalleryCard
            key={item.id}
            item={item}
            onClick={() => setSelectedImage(item.image)}
          />
        ))}
      </div>

      {/* ✅ Lightbox Modal */}
      {selectedImage && (
        <div
          className="modal"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Preview"
            className="modal-img"
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;